import { createContext } from "react";
export const WorkLanguage = createContext({ plural: "Work", singular: "work item" });
export const workItemName = (labels: { singular: string }) =>
  labels.singular.charAt(0).toUpperCase() + labels.singular.slice(1);
